import { Ajax } from "../Common/Ajax";
import { GlobalData } from "../Common/GlobalData";
import { Notification } from "../Common/KendoHelpers";

export class Quandl {
    private static readonly SPINNER = '#spinner';

    public constructor() {
        this.defineEvents();
    }

    private defineEvents() {
        $('#updateGeneral').off('click').on('click', () => {
            this.updateQuandl('updateGeneral');
        });

        $('#updateMetadata').off('click').on('click', () => {
            this.updateQuandl('updateMetadata');
        });
    }

    public updateQuandl(type: string) {
        $(Quandl.SPINNER).show();
        const notification = new Notification(Notification.reloadPage);

        const success = (message: string) => {
            message = '<br>' + message.replace(/\n/g, '<br>');
            notification.success(message);
        }

        const error = (x: any) => {
            notification.error(x.responseText);
        }

        const complete = () => {
            $(Quandl.SPINNER).hide();
        }

        Ajax.invoke(GlobalData.URL_SUFFIX_IMPORT_DATA + '/' + type,
            "POST", null, success, error, complete);
    }
}
